export default {
  Title: 'Reviews',
  FrequentlyMentionedSubtitle: 'Frequently mentioned by families',
  HaveToSaySubtitle: 'What past clients have to say',
};
